import React from "react";

type SubscriptionItemContextType = {
    tdsTaxes: any[]
    getTdsDropDownList: () => void;
  };

export const SubscriptionItemContext = React.createContext<SubscriptionItemContextType>({tdsTaxes: [], getTdsDropDownList: () => {}});

export const useSubscriptionItemContext = () => React.useContext(SubscriptionItemContext);